import * as React from 'react';

import moment from 'moment';

import {isToday} from 'nutshell-core/date-time';

import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

type Props = {
    submissionTime: number;
    prependSubmitted?: boolean;
};

export function FormSubmissionTimestamp(props: Props) {
    const {submissionTime, prependSubmitted = true} = props;

    if (isToday(moment.unix(submissionTime))) {
        return (
            <div className='flex'>
                {prependSubmitted && <>submitted&nbsp;</>}
                <RelativeTimestamp datetime={submissionTime} />
            </div>
        );
    }

    return (
        <div className='flex'>
            {prependSubmitted && <>submitted on&nbsp;</>}
            <FormattedTimestamp
                datetime={submissionTime}
                format={FormattedTimestamp.formats.longMonthDayWithYear}
            />
        </div>
    );
}
